import { isEqual } from 'lodash'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import AdjustmentsTable from '../../components/PendingAdjustmentTable'
import { actions, initialState } from '../../StockAdjustmentInBatchState'
import * as S from './PendingAdjustmentPage.styles'

export default () => {
  const dispatch = useDispatch()
  const { filters } = useSelector((state) => state.stockAdjustmentInBatch)

  useEffect(() => {
    dispatch(actions.reset())

    const hasHistorySelectedFilters = !isEqual(filters, initialState.filters)
    if (hasHistorySelectedFilters) {
      dispatch(actions.setFilters(filters))
    }
  }, [dispatch, filters])

  return (
    <S.Wrapper>
      <S.Title>Ajustes Pendentes</S.Title>
      <AdjustmentsTable/>
    </S.Wrapper>
  )
}
